import React, {useState} from 'react'
import {RedoOutlined} from "@ant-design/icons"
import {refreshAccessToken} from "../../../api/clubPlatform"
import {message, Modal, Result} from "antd"
import {useClubPlatformContext} from "../store/useClubPlatformContext"


const ClubPlatformAuthRefresh = ({merchantId}) => {
    const {getRelationStore} = useClubPlatformContext()

    const [isLoading, setIsLoading] = useState(false)
    const [isShow, setIsShow] = useState(false)


    const refreshToken = async () => {
        setIsLoading(true)
        await refreshAccessToken(merchantId).then(res => {
            if (res.status !== 1) {
                message.error(`刷新授权失败${res.detail}`)
                return
            }
            setIsShow(false)
            getRelationStore()
            message.success("刷新授权成功")
        }).catch(err => {
            message.error(`刷新授权失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }
    const handleClick = () => {
        setIsShow(true)
    }

    return (
        <div>
            <div onClick={handleClick}>
                <RedoOutlined/>
                <span style={{marginLeft: "5px"}}>{"刷新授权"}</span>
            </div>
            <Modal
                open={isShow}
                onOk={refreshToken}
                onCancel={() => {
                    setIsShow(false)
                }}
                confirmLoading={isLoading}
            >
                <Result
                    title={"确定要刷新授权吗？"}
                    subTitle={"刷新授权会消耗刷新次数，1年之内最多刷新12次"}
                    status={"warning"}
                    style={{padding: 20}}
                />
            </Modal>
        </div>
    )
}

export default ClubPlatformAuthRefresh


// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformAuthRefresh.js